module.exports = __webpack_public_path__ + "static/media/video-2-icon.3f3258f4.svg";